export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/uploads.8843d095.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};